import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../index.module.sass';
import superagent from 'superagent';

const Records = (props) => {
  const { records, screenSize } = props;
  const { t } = useTranslation('branch');
  const tableData = records;

  const recordsItems = t('records', { returnObjects: true });
  const dataCellWidth = (screenSize === 'phone' && '180px') || `${100 / recordsItems.length}%`;

  function downloadItem(url, name) {
    superagent
      .get(url)
      .responseType('blob')
      .then((response) => {
        const blob = new Blob([response.body], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = name;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch(console.error);
  }

  return (
    <div className={styles.optionContainer}>
      <div className={`${styles.tableContainer} ${styles[screenSize]}`}>
        <div className={styles.table}>
          <div className={`${styles.row} ${styles.tableHeader}`}>
            {recordsItems.map((val, key) => {
              const { title = '', size = '' } = val;
              return (
                <div
                  className={`${styles.cell} ${styles.headerCell}`}
                  style={{
                    width: (size !== '' && screenSize !== 'phone' && size) || dataCellWidth,
                  }}
                  key={key}>
                  {title}
                </div>
              );
            })}
          </div>
          {tableData.map((val, key) => {
            const columns = recordsItems.map((cellVal, cellKey) => {
              const {
                field = '',
                many = false,
                isLink = false,
                title = '',
                useLength = false,
                isMoney = false,
                isImage = false,
                callbackText = '',
                size = '',
              } = cellVal;
              let fieldName = '';
              if (many) {
                const tmpConst = field.split(',');
                for (let i = 0; i < tmpConst.length; i++) {
                  if (i > 0) fieldName += '-';
                  fieldName += (tableData[key] && tableData[key][tmpConst[i]]) || '';
                }
              } else if (useLength) {
                fieldName = tableData[key] && tableData[key][field] && tableData[key][field].length;
              } else {
                fieldName = (tableData[key] && tableData[key][field]) || '';
                if (isMoney) fieldName = `$${fieldName}`;
              }
              const cell = (
                <div
                  className={styles.cell}
                  style={{
                    width: (size !== '' && screenSize !== 'phone' && size) || dataCellWidth,
                  }}
                  key={cellKey}>
                  {(isLink && val?.callback && (
                    <div
                      className={styles.callback}
                      onClick={() => val?.callback(val?.callbackArgs)}>
                      {callbackText}
                    </div>
                  )) ||
                    (isLink && (
                      <div className={styles.link} onClick={() => downloadItem(fieldName, title)}>
                        {title}
                      </div>
                    )) ||
                    (isImage && <img src={tableData[key][field]} alt='' />) || (
                      <span className={styles.cellSpan}>{fieldName}</span>
                    )}
                </div>
              );
              return cell;
            });
            return (
              <div className={styles.row} key={key}>
                {columns}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Records;
